var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var diagramConfiguration = require('../diagramConfiguration');
var editCustomEquipmentModal = require('../../../editCustomEquipmentModal');
var loaders = require('../../../../layout/components/loaders');
var $ = go.GraphObject.make;  // for more concise visual tree definitions


function createGroupNodeTemplate(map, useGeoPositioning, submitCallback) {
  return $(go.Node, "Auto",
    {
      locationSpot: go.Spot.TopLeft,
      layerName: "Background",
      resizable: true,  // Enable resizing
      resizeObjectName: "SHAPE",  // Identify which object is resized
      doubleClick: function(e, obj) {
        // Optionally, you could also open a modal here instead of inline editing
        var textBlock = obj.findObject("LABEL");  // Get the text block in this node
        if (textBlock && edit.vm.editing()) {
          e.diagram.commandHandler.editTextBlock(textBlock);
        }
      }
    },
    new go.Binding("deletable", "", data => edit.vm.editing()),
    new go.Binding("selectable", "", data => edit.vm.editing()),
    new go.Binding("movable", "", data => edit.vm.editing()),
    useGeoPositioning ? 
      new go.Binding("location", "latlong", data => {
        const pos = map.project(data, map.getZoom());
        return new go.Point(pos.x, pos.y);
      }).makeTwoWay((pt, data) => {
        if (updatingGoJs) {
          return data.latlong; // no-op
        } else {
          const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
          return [ll.lat, ll.lng];
        }
      })
    : 
      new go.Binding("location", "latlong", data => {
        return new go.Point(data[0], data[1]);
      }),
    $(go.Shape, "Rectangle", {
      name: "SHAPE",
      portId: "", 
      fromLinkable: false, 
      toLinkable: false,
      fill: null,
      strokeWidth: 2,
    },
      new go.Binding("height", "height"),
      new go.Binding("width", "width"),
      new go.Binding("stroke", "color")
    ),
    $(go.TextBlock, {
      alignment: go.Spot.TopCenter,
      editable: true,
      stroke: "white",
      isMultiline: false,
      wrap: go.TextBlock.None,
      font: `500 ${diagramConfiguration.fontSize - 2}pt 'Roboto Flex', monospace`,
      textEdited: function(textBlock, previousText, currentText) {
        let groupRecord = this.part.data;
        let groupEdited = groupRecord.parentRecordGroups.find(group => `${group.id}` == groupRecord.key);
        groupEdited.name = currentText;
        return loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/customequipment/' + groupRecord.parentRid.slice(1) + '/groups',
          method: 'PUT',
          body: groupRecord.parentRecordGroups
        })
      }
    },
      new go.Binding("text", "name").makeTwoWay(),  // Two-way binding on label property
      { name: "LABEL" }  // Identify this TextBlock in the node
    )
  );
}





module.exports = createGroupNodeTemplate;
